import { makeStyles, Theme } from '@material-ui/core'

import { AlertProps } from './AlertProps'

export const useAlertStyles = makeStyles<Theme, AlertProps, 'root'>((theme) => ({
  root: {
    alignItems: 'center',
    width: ({ fullWidth }) => (fullWidth ? '100%' : 'unset'),
    background: 'white',
    borderColor: (props) => theme.palette[props.severity || 'error'].main,
    borderLeft: `${theme.spacing(1)}px solid`,
    color: theme.palette.text.primary,
  },
  icon: {
    alignSelf: 'start',
  },
}))
